import { render, staticRenderFns } from "./ModalLicenseAddDate.vue?vue&type=template&id=36250108&scoped=true&"
import script from "./ModalLicenseAddDate.vue?vue&type=script&lang=js&"
export * from "./ModalLicenseAddDate.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenseAddDate.vue?vue&type=style&index=0&id=36250108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36250108",
  null
  
)

export default component.exports